import { useContext, useEffect, useState } from "react";
import { ToastContext } from "../../context/ToastContext";
import User from "../../models/User";
import AccountService from "../../services/crud/AccountService";
import UserService from "../../services/crud/UserService";
import { formatPointsInCents } from "../../utils/common";
import { WalletFormButton } from "../WalletFormButton";
import { Button } from "antd";
import { GenericWalletTransactionsTable } from "./WalletTransactionsTable";

interface WalletTableParams {
  userId: number;
}

export const WalletTable = ({userId}: WalletTableParams) => {
  const { loading, loadMessage, showMessage } = useContext(ToastContext);

  const [user, setUser] = useState<User|null>(null);
  const [accountId, setAccountId] = useState<number|null>(null);
  const [balanceCents, setBalanceCents] = useState<number|null>(null);
  const [refreshId, setRefreshId] = useState<number>(0);

  useEffect(() => {
    loadMessage("Loading...", async () => {
      const [privateAccount, user] = await Promise.all([
        AccountService.getUserPrivateAccount(userId),
        userId ? UserService.getUser(userId) : Promise.resolve<User|null>(null),
      ])

      setUser(user);
      setBalanceCents(privateAccount.balanceCents);
      setAccountId(privateAccount.id);
    }).finally(() => {
      return "Loaded wallet";
    });
  }, [userId]);

  const refresh = async () => {
    setRefreshId(refreshId + 1); // trigger table refresh
    const privateAccount = await AccountService.getUserPrivateAccount(userId);
    setBalanceCents(privateAccount.balanceCents);
  }


  return (
    <div>
      <div></div>
      <p style={{fontSize: 16}}>Balance: {formatPointsInCents(balanceCents, 'long') ?? ''}</p>
      <Button onClick={refresh} >Refresh balance</Button>
      <WalletFormButton
        userId={userId}
        buttonLabel="Change balance"
        onBalanceChange={(newBalanceCents) => {
          console.log('Balance changed');
          setBalanceCents(newBalanceCents);
          setRefreshId(refreshId + 1);
        }}
      />


      <h2 style={{marginTop: 30, marginBottom: -10}}>Transactions</h2>
      { accountId !== null && (
        <GenericWalletTransactionsTable accountId={accountId} key={`${accountId}-${refreshId}`} />
      ) }
    </div>
  );
};